import { Col, Row } from "@/utils/bootstrap";
import SVgAuthBack from "./SVgAuthBack";

interface Props {
  title: string;
  onClickBack?: () => void;
}

const PCAuthHeader: React.FC<Props> = ({ title, onClickBack }) => {
  return (
    <Row xs={12} className="m-0 align-items-center auth-pc-header">
      <Col className="p-0">
        <SVgAuthBack onClickBack={onClickBack} />
      </Col>
      <Col className="p-0 d-flex justify-content-center text-nowrap">
        {title}
      </Col>
      <Col className="p-0" />
    </Row>
  );
};

export default PCAuthHeader;
